import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';

const allowedCategories = ['Makeup', 'Hair'];

export const useShouldShowShadeListButton = () => {
  const {
    variantGroups: { showGroups, selectedGroup },
    product,
    currentVariant,
  } = useProductDetailContext();

  const selectedCategoryName = currentVariant.primaryCategories?.category?.name;

  const isAllowedCategory =
    selectedCategoryName &&
    allowedCategories.some((category) =>
      selectedCategoryName.includes(category)
    );

  const variants =
    showGroups && selectedGroup
      ? selectedGroup.variants
      : product?.variants ?? [];

  const shouldShowShadeListButton =
    isAllowedCategory &&
    variants.length > 1 &&
    product?.variantDisplayType === 'ColorPicker';

  return { shouldShowShadeListButton };
};
